<section class="side-messages">
  <div *ngFor="let message of messages">
    <div class="side-message message-added"
         id={{message.id}}
         [ngClass]="{'info': message.type === TYPES.INFO, 'error': message.type === TYPES.ERROR}"
         *ngIf="message.type !== TYPES.CUSTOM">
      <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17"
           (click)="removeMessage(message)" class="cross-close">
        <g fill="none" fill-rule="evenodd">
          <circle cx="8.5" cy="8.5" r="8.5" fill="currentColor"/>
          <path stroke="#FFF" stroke-linecap="round" d="M6 6l5.657 5.657M11.657 6L6 11.657"/>
        </g>
      </svg>
      <div class="message-text row">
        <span [innerHTML]="message.context.text"></span>
      </div>
    </div>
    <div class="message-added" id={{message.id}} *ngIf="message.type === TYPES.CUSTOM">
      <ng-container *ngTemplateOutlet="message.template; context: {id: message.id, context: message.context}">
      </ng-container>
    </div>
  </div>
</section>
